import React from 'react';
import BirdAvatarWithJailbirdEyes from './BirdAvatarWithJailbirdEyes';

// ALL 49 ADORABLE BIRD AVATARS with JailBirds eyes!
export const BIRD_AVATARS = [
  // BRIGHT & CHEERFUL (Gender Neutral)
  { id: 2, color: '#4ECDC4', accessory: 'tiny-glasses', name: 'Smarty', description: 'Nerdy & Proud' },
  { id: 3, color: '#FFD93D', accessory: 'tiny-bow', name: 'Sunny', description: 'Bright & Cheerful' },
  { id: 5, color: '#FF8ED4', accessory: 'heart', name: 'Sweetheart', description: 'Full of Love' },
  { id: 8, color: '#6FEDD6', accessory: 'star', name: 'Starry', description: 'Dreamy & Magical' },
  { id: 9, color: '#FFB347', accessory: 'cool-shades', name: 'Chill', description: 'Too Cool for School' },
  { id: 17, color: '#FFD700', accessory: 'sparkle', name: 'Glitter', description: 'Sparkly & Shiny' },
  { id: 32, color: '#FFED4E', accessory: 'sunburst', name: 'Sunshine', description: 'Bright & Warm' },
  
  // CUTE ANIMALS (Gender Neutral)
  { id: 21, color: '#FFB3E6', accessory: 'bunny-ears', name: 'Cottontail', description: 'Hoppy & Bouncy' },
  { id: 23, color: '#FFA5BA', accessory: 'cat-ears', name: 'Whiskers', description: 'Purr-fectly Cute' },
  { id: 26, color: '#B4F8C8', accessory: 'bear-ears', name: 'Teddy', description: 'Cuddly & Warm' },
  { id: 41, color: '#FFFFFF', accessory: 'panda', name: 'Bamboo', description: 'Cuddly Panda' },
  { id: 45, color: '#90EE90', accessory: 'frog-hat', name: 'Hoppy', description: 'Froggy Friend' },
  { id: 37, color: '#FFB7B2', accessory: 'bee-wings', name: 'Buzzy', description: 'Busy Bee' },
  
  // SWEET TREATS (Gender Neutral)
  { id: 22, color: '#B4E7CE', accessory: 'donut', name: 'Sprinkles', description: 'Sweet as Sugar' },
  { id: 24, color: '#A0E7E5', accessory: 'ice-cream', name: 'Frosty', description: 'Cool & Sweet' },
  { id: 33, color: '#FFD1DC', accessory: 'lollipop', name: 'Candy', description: 'Super Sweet' },
  { id: 43, color: '#FF6B6B', accessory: 'strawberry', name: 'Berry', description: 'Sweet Berry' },
  { id: 39, color: '#FFDFD3', accessory: 'cookie', name: 'Chips', description: 'Freshly Baked' },
  { id: 19, color: '#F7B2BD', accessory: 'cherry', name: 'Cherry', description: 'Sweet & Juicy' },
  
  // MAGICAL & FANTASY (Feminine)
  { id: 42, color: '#FFB3FF', accessory: 'unicorn', name: 'Magic', description: 'Sparkly Unicorn' },
  { id: 6, color: '#C7A4FF', accessory: 'tiny-crown', name: 'Royal', description: 'Fancy & Fabulous' },
  { id: 7, color: '#FFB6C1', accessory: 'flower', name: 'Blossom', description: 'Pretty in Pink' },
  { id: 25, color: '#FFAEBC', accessory: 'rainbow', name: 'Sunny Day', description: 'Colorful & Happy' },
  { id: 29, color: '#FFCFD2', accessory: 'balloon', name: 'Float', description: 'Light as Air' },
  { id: 47, color: '#9370DB', accessory: 'witch-hat', name: 'Spooky', description: 'Magical Witch' },
  { id: 20, color: '#DDA0DD', accessory: 'butterfly', name: 'Flutter', description: 'Light & Graceful' },
  
  // COOL & EDGY (Masculine)
  { id: 14, color: '#84B6F4', accessory: 'mustache', name: 'Gentleman', description: 'Classy & Dapper' },
  { id: 13, color: '#FF6F61', accessory: 'bandana', name: 'Rebel', description: 'Wild & Free' },
  { id: 46, color: '#E0E0E0', accessory: 'astronaut', name: 'Cosmo', description: 'Space Explorer' },
  { id: 34, color: '#B9FBC0', accessory: 'game-controller', name: 'Gamer', description: 'Ready to Play' },
  { id: 31, color: '#90DBF4', accessory: 'music-note', name: 'Melody', description: 'Always Singing' },
  
  // DARK & MYSTERIOUS (Gender Neutral)
  { id: 51, color: '#2C3E50', accessory: 'tiny-glasses', name: 'Shadow', description: 'Dark & Mysterious' },
  { id: 52, color: '#34495E', accessory: 'cool-shades', name: 'Midnight', description: 'Night Owl' },
  { id: 53, color: '#1A1A2E', accessory: 'star', name: 'Eclipse', description: 'Dark Star' },
  { id: 54, color: '#16213E', accessory: 'tiny-crown', name: 'Obsidian', description: 'Dark Royalty' },
  
  // NEON & ELECTRIC (Gender Neutral)
  { id: 55, color: '#00FF00', accessory: 'sparkle', name: 'Neon', description: 'Electric Green' },
  { id: 56, color: '#FF00FF', accessory: 'star', name: 'Rave', description: 'Party Vibes' },
  { id: 57, color: '#00FFFF', accessory: 'sunburst', name: 'Cyber', description: 'Digital Dream' },
  { id: 58, color: '#FF1493', accessory: 'lightning', name: 'Volt', description: 'High Energy' },
  
  // FUN & QUIRKY (Gender Neutral)
  { id: 10, color: '#B19CD9', accessory: 'party-hat', name: 'Party', description: 'Always Celebrating' },
  { id: 44, color: '#8B7355', accessory: 'coffee', name: 'Mocha', description: 'Cozy Café' },
  { id: 48, color: '#FFB6C1', accessory: 'headphones', name: 'Beats', description: 'Music Lover' },
  { id: 49, color: '#FFE5B4', accessory: 'sushi', name: 'Wasabi', description: 'Sushi Roll' },
  { id: 50, color: '#C1E1C1', accessory: 'avocado', name: 'Guac', description: 'Avo-cutie' },
  { id: 38, color: '#E2F0CB', accessory: 'cactus', name: 'Prickles', description: 'Sharp but Sweet' },
  { id: 27, color: '#FBE7C6', accessory: 'pizza', name: 'Pepperoni', description: 'Cheesy & Fun' },
  { id: 28, color: '#A0C4FF', accessory: 'moon', name: 'Dreamer', description: 'Sleepy & Peaceful' },
  { id: 35, color: '#FEC8D8', accessory: 'present', name: 'Gift', description: 'Full of Surprises' },
  { id: 36, color: '#D4F1F4', accessory: 'snowflake', name: 'Frosty', description: 'Cool & Crisp' }
];

const BirdAvatar = ({ avatarId = 2, size = 40, showAccessory = true, className = '', animate = true }) => {
  const avatar = BIRD_AVATARS.find(a => a.id === avatarId) || BIRD_AVATARS[0];
  
  // Use the new component with JailBirds eyes
  return (
    <BirdAvatarWithJailbirdEyes
      avatarId={avatarId}
      color={avatar.color}
      accessory={avatar.accessory}
      size={size}
      className={className}
    />
  );
};

export default BirdAvatar;
